<template>
    <div class="load-authorizations-results">
        <div class="row">
            <div class="col-12 col-sm">
                <span class="result-section">{{ authorizations.length }} Autorizaciones Cargadas</span>
            </div>
        </div>
        <div class="row alert alert-danger errors-section" v-if="errors.length > 0">
            <div class="col">
                <h4>Errores ({{ errors.length }})</h4>
                <ol>
                    <li v-for="error in errors">
                        {{ error }}
                    </li>
                </ol>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            authorizations: {
                type: Array
            },
            errors: {
                type: Array
            }
        }
    }
</script>
<style scoped>
    .load-authorizations-results {
        margin-top: 15px;
        padding: 15px;
    }
    .result-section {
        font-weight: 900;
        text-align: center;
    }
    .errors-section {
        height: 200px;
        overflow: auto;
    }
</style>